module.exports = __webpack_public_path__ + "static/media/blinds.a93d9020.svg";